module.exports = __webpack_public_path__ + "img/icon-plus.d98bd64d.svg";